import { render, staticRenderFns } from "./EqifyRulePersonHasAge.vue?vue&type=template&id=a0c7dc0a&scoped=true"
import script from "./EqifyRulePersonHasAge.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonHasAge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7dc0a",
  null
  
)

export default component.exports